import React from 'react';
import { IonList, IonItem, IonIcon, IonLabel, IonBadge } from '@ionic/react';
import { 
  headsetOutline,
  personCircleOutline,
  peopleOutline,
  briefcaseOutline,
  cardOutline,
  copyOutline,
  trophyOutline,
  barChartOutline,
  closeCircleOutline,
  arrowBackOutline,
  trashOutline
} from 'ionicons/icons';

interface AdminSidebarProps {
  onMenuItemClick: (action: string) => void;
  activeItem?: string;
  supportMonkeysUnreadCount?: number;
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({
  onMenuItemClick,
  activeItem,
  supportMonkeysUnreadCount = 0,
}) => {
  const menuItems = [
    {
      id: 'supportMonkeys',
      icon: headsetOutline,
      label: 'Support Monkeys',
      badge: supportMonkeysUnreadCount,
    },
    { 
      id: 'impersonate', 
      icon: personCircleOutline, 
      label: 'Impersonate User',
    },
    { 
      id: 'payingUsers', 
      icon: cardOutline, 
      label: 'Paying Users',
    },
    { 
      id: 'payingWerkers', 
      icon: peopleOutline, 
      label: 'Paying Werkers',
      disabled: true
    },
    { 
      id: 'schedulerDashboard', 
      icon: briefcaseOutline, 
      label: 'Scheduler Job Dashboard',
    },
    { 
      id: 'doubleBookings', 
      icon: copyOutline, 
      label: 'Scheduler Doublebooks',
    },
    { 
      id: 'schedulerRanking', 
      icon: trophyOutline, 
      label: 'Scheduler Ranking',
    },
    {
      id: 'usersReport',
      icon: barChartOutline,
      label: 'Users Report',
    },
    {
      id: 'deleteUserDocs',
      icon: trashOutline,
      label: 'Delete User Docs',
    },
  ];

  return (
    <div style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      borderRight: '1px solid #ddd'
    }}>
      <IonList style={{ flex: 1, padding: '20px 10px' }}>
        {menuItems.map((item) => (
          <IonItem
            key={item.id}
            button
            onClick={() => !item.disabled && onMenuItemClick(item.id)}
            disabled={item.disabled}
            color={activeItem === item.id ? 'light' : undefined}
            lines="none"
            style={{
              marginBottom: '8px',
              borderRadius: '8px',
              fontWeight: activeItem === item.id ? 'bold' : 'normal',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              opacity: item.disabled ? 0.5 : 1
            }}
          >
            <IonIcon icon={item.icon} slot="start" />
            <IonLabel>{item.label}</IonLabel>
            {Number(item?.badge) > 0 && (
              <IonBadge slot="end" color="danger">
                {item.badge}
              </IonBadge>
            )}
          </IonItem>
        ))}
        
        {/* Separator */}
        <div style={{ 
          borderTop: '1px solid #ddd', 
          margin: '16px 8px', 
        }} />
        
        {/* Clear Panel Button */}
        <IonItem
          button
          onClick={() => onMenuItemClick('clear')}
          color={activeItem === 'clear' ? 'light' : undefined}
          lines="none"
          style={{
            marginBottom: '8px',
            borderRadius: '8px',
          }}
        >
          <IonIcon icon={closeCircleOutline} slot="start" />
          <IonLabel>Clear Panel</IonLabel>
        </IonItem>
        
        {/* Exit Admin Button */}
        <IonItem
          button
          onClick={() => onMenuItemClick('exit')}
          lines="none"
          style={{
            marginBottom: '8px',
            borderRadius: '8px',
            color: 'var(--ion-color-danger)'
          }}
        >
          <IonIcon icon={arrowBackOutline} slot="start" color="danger" />
          <IonLabel color="danger">Exit Admin</IonLabel>
        </IonItem>
      </IonList>
    </div>
  );
};

export default AdminSidebar;
